import axios from 'axios';
import i18n from '@/i18n';
import useAppStore from '@/store/appStore';

export default {
  clearCache: false,
  getAxios() {
    if (!this.appStore) { this.appStore = useAppStore(); }
    const apiClient = axios.create({
      baseURL: `${this.appStore.modele.urlBase}/api`,
      headers: {
        Accept: 'application/json',
        'Access-Control-Allow-Origincommon': '*',
        'Content-Type': 'application/json',
      },
    });

    apiClient.interceptors.request.use((config) => {
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      return config;
    });

    apiClient.interceptors.response.use((response) => {
      // Si c'est un type APIReponse, on le catch et en extrait l'objet de retour
      if (response.data) {
        if (response.data.succes) {
          if (response.data.succes === true) {
            return response.data.resultat;
          }
        }
      }
      return response;
    // eslint-disable-next-line consistent-return
    }, (error) => {
      if (error.response) {
        // Log l'erreur pour le débogage
        console.error('Erreur HTTP: ', error.response);

        // Erreur 403 - Accès non-autorisé (ApiResponse.Error('403'))
        if (error.response.status === 403) {
          console.log('Accès non-autorisé / Access Forbidden');
          if (!(window.location.href.indexOf('/E403') > -1)) {
            // eslint-disable-next-line no-return-assign
            return window.location.href = `${this.appStore.modele.urlBase}/#/E403`;
          }
          return error;
        }

        // Extraire les informations d'erreur du backend
        const { data } = error.response;

        // Rejeter la promesse avec les détails de l'erreur
        return Promise.reject(data?.resultat || i18n.t('message.unknown'));
      } if (error.request) {
        // Cas où la requête a été envoyée mais aucune réponse n'a été reçue
        console.error('Erreur de requête : aucune réponse reçue');
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
          status: 0,
          message: 'Erreur réseau : impossible de joindre le serveur.',
        });
      }
      // Cas où une erreur s'est produite lors de la configuration de la requête
      console.error('Erreur inconnue Axios :', error.message);
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        status: null,
        message: error.message || i18n.t('message.unknown'),
      });
    });

    return apiClient;
  },
};
